"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var form_group_with_select_1 = require("../components/form_group_with_select");
var rql_1 = require("../rql");
var bind_1 = require("../bind");
function inventoryOption(offset) {
    var displayQuantity = "" + (offset + 1);
    return { text: displayQuantity, value: displayQuantity };
}
var OfferQuantitySelect = /** @class */ (function (_super) {
    tslib_1.__extends(OfferQuantitySelect, _super);
    function OfferQuantitySelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OfferQuantitySelect.prototype.onSelect = function (inputOffer) {
        this.props.onQuantityChange({
            quantity: parseInt(inputOffer.quantity, 10),
        });
    };
    OfferQuantitySelect.prototype.render = function () {
        var inventoryOptions = lodash_1.times(this.props.inventory, inventoryOption);
        return (React.createElement(form_group_with_select_1.default, { label: I18n.t('commons.offers.offerQuantity'), inputName: "offer-quantity", fieldName: "quantity", options: inventoryOptions, value: "" + this.props.quantity, updateField: this.onSelect, disabled: this.props.party === rql_1.core_apimessages_NegotiationParty.BUYER }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], OfferQuantitySelect.prototype, "onSelect", null);
    return OfferQuantitySelect;
}(React.Component));
exports.default = OfferQuantitySelect;
//# sourceMappingURL=offer_quantity_select.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_quantity_select.js
// module id = /YcO
// module chunks = 20 21